var map = {
	"./forschungslabor/forschungslabor.json": 6386,
	"./hedera/hedera.json": 5733,
	"./hosenrolle/hosenrolle.json": 1087,
	"./ich-bin-schon-tot/ich-bin-schon-tot.json": 8808,
	"./ich-werde-tier-sein/ich-werde-tier-sein.json": 2190,
	"./phantomschmerz/phantomschmerz.json": 5159,
	"./project-covers/project-covers.json": 8722
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6803;
module.exports = webpackAsyncContext;